import { TweenMax, Expo, ScrollToPlugin } from 'gsap/all';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import hades from '@/scripts/hades';
import utils from '@/scripts/utils';

const plugins = [ScrollToPlugin]; // eslint-disable-line

Vue.config.productionTip = false;
sync(store, router);

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$goTo = (link, trans) => {
  if (trans === 'lang') {
    store.commit('SET_LANG', link.substr(1));
    store.commit('SET_TRANSNAME', 'default');
    router.push(link);
  } else if (trans === 'logo') {
    store.commit('SET_GOHOME', true);
    store.commit('SET_TRANSNAME', 'default');
    router.push(link);
  } else if (trans !== 'top') {
    store.commit('SET_TRANSNAME', trans);
    router.push(link);
  } else {
    if (utils.isTouchDevice()) {
      TweenMax.to(window, 1.2, {
        scrollTo: {
          y: 0,
        },
        ease: Expo.easeOut,
      });
    } else {
      hades.ref.scrollTo({y: 0}, 1200);
    }
  }
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
